import "./NationalSeo.module.css";
import Header from "@/reusable_sections/Header";
import Nationalseo from "./sections/Nationalseo";
import WhatIsNationalSEO from "./sections/WhatIsNationalSEO";
import NationalVsLocalComparison from "./sections/NationalVsLocalComparison";
import ServicePillars from "./sections/ServicePillars";
import Process from "./sections/Process";
import Benefits from "./sections/Benefits";
import Nationalfaq from "./sections/Nationalfaq";
import Nationalsearchcta from "./sections/Nationalsearchcta";
import Footer from "@/reusable_sections/Footer";
export default function NationalSeoPage() {
  return <div>
      <Header />
      <Nationalseo />
      <WhatIsNationalSEO />
      <NationalVsLocalComparison />
      <ServicePillars />
      <Process />
      <Benefits />
      <Nationalfaq />
      <Nationalsearchcta />
      <Footer />
    </div>;
}